'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ColorSlider", {
    enumerable: true,
    get: function() {
        return ColorSlider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useColorSlider = require("./useColorSlider");
const _renderColorSlider = require("./renderColorSlider");
const _useColorSliderStylesstyles = require("./useColorSliderStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ColorSlider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useColorSlider.useColorSlider_unstable)(props, ref);
    (0, _useColorSliderStylesstyles.useColorSliderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useColorSliderStyles_unstable')(state);
    return (0, _renderColorSlider.renderColorSlider_unstable)(state);
});
ColorSlider.displayName = 'ColorSlider';
